const PageTitle = ({ text }: { text: string }) => {
  return <div className='font-[DKLiquidEmbrace] text-primary text-[40px] leading-[28px]'>{text}</div>;
};

export default PageTitle;
